var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTopBgClosingMobile = function SvgTopBgClosingMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-229.695 87.676h102.264a50.145 50.145 0 0 1 34.453 13.71l26.347 24.913a50.145 50.145 0 0 0 34.452 13.709h44.364",
    stroke: "#FEF9C3",
    strokeWidth: 14.8
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-mobile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.785 82.384h-18.087a50.146 50.146 0 0 0-38.685 18.238l-5.076 6.154a50.146 50.146 0 0 1-38.684 18.238h-44.118",
    stroke: "#95FFE4",
    strokeOpacity: 0.56,
    strokeWidth: 14.8
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7 37.108H5.733a50.146 50.146 0 0 1-33.778-13.083l-2.902-2.645A50.146 50.146 0 0 0-64.725 8.296h-20.112",
    stroke: "#265761",
    strokeWidth: 14.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.578 37.108h43.626",
    stroke: "#14353B",
    strokeWidth: 14.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M129.785 82.384h53.829",
    stroke: "#ABE7ED",
    strokeWidth: 14.8
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-181.27 110.315h131.2a50.146 50.146 0 0 0 37.4-16.744l22.318-24.99a50.145 50.145 0 0 1 37.393-16.743l176.821-.03",
    stroke: "#327987",
    strokeWidth: 14.8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.063 140.009h43.626",
    stroke: "#FFF7E0",
    strokeWidth: 14.8
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M619.695 65.038H476.14a50.145 50.145 0 0 0-29.73 9.764l-54.725 40.289a50.145 50.145 0 0 1-29.729 9.763H221.853",
    stroke: "#ABE7ED",
    strokeWidth: 14.8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M510.406 13.588h-82.574a50.146 50.146 0 0 0-29.958 9.932l-42.397 31.585a50.146 50.146 0 0 1-29.958 9.933h-41.493",
    stroke: "#265761",
    strokeWidth: 14.8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M273.141 65.038h43.626",
    stroke: "#327987",
    strokeWidth: 14.8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-mobile_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.918 79.867H293.085a50.144 50.144 0 0 0-37.503 16.858l-10.146 11.431a50.147 50.147 0 0 1-37.504 16.858h-54.68",
    stroke: "#FFF1C0",
    strokeOpacity: 0.4,
    strokeWidth: 14.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#top-bg-closing-mobile_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.879 160H359.566a50.148 50.148 0 0 1-28.07-8.593l-26.785-18.095a50.147 50.147 0 0 0-28.071-8.592H129.791",
    stroke: "#95FFE4",
    strokeOpacity: 0.56,
    strokeWidth: 14.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-mobile_svg__a",
    x: -25.449,
    y: 64.4,
    width: 165.818,
    height: 78.598,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.292
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-mobile_svg__b",
    x: 130.908,
    y: 50.123,
    width: 294.354,
    height: 104.635,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 11.172
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17238",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "top-bg-closing-mobile_svg__c",
    x: 119.207,
    y: 106.735,
    width: 389.256,
    height: 71.248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 5.292
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4234_17238"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_backgroundBlur_4234_17238",
    result: "shape"
  })))));
};
export { SvgTopBgClosingMobile as ReactComponent };
export default "data:image/svg+xml;base64,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";